var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"block","background-color":"rgb(50, 115, 245)"}},_vm._l((_vm.urls),function(url){return _c('el-image',{key:url.name,staticStyle:{"width":"100%","background-color":"rgb(50, 115, 245)"},attrs:{"src":url.path,"lazy":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }